import React from "react";

const DescriptionCard = ({
  title,
  description,
  style = {},
  titleStyle = {},
  descriptionStyle = {},
}) => {
  return (
    <div style={{ ...baseStyles.card, ...style }}>
      <div style={{ ...baseStyles.title, ...titleStyle }}>{title}</div>
      <div style={{ ...baseStyles.description, ...descriptionStyle }}>
        {description}
      </div>
    </div>
  );
};

const baseStyles = {
  card: {
    padding: "16px 20px",
    background: "#fff",
    boxSizing: "border-box",
  },
  title: {
    fontSize: "24px",
    fontWeight: 500,
    lineHeight: 1.2,
    marginBottom: "8px",
    color: "#000",
  },
  description: {
    fontSize: "14px",
    color: "#6b7280",
    lineHeight: 1.4,
    fontWeight: 400,
  },
};

export default DescriptionCard;
